export const SET_AUTH = 'SET_AUTH'
export const SET_NEXT_ROUTE = 'SET_NEXT_ROUTE'
export const SET_FROM_ROUTE = 'SET_FROM_ROUTE'
export const SET_LOADING = 'SET_LOADING'
export const SET_LOGIN = 'SET_LOGIN'
export const SET_MFA_ERROR = 'SET_MFA_ERROR'
export const RESET_AUTH = 'SET_AUTH'
export const RESET_MFA_ERROR = 'RESET_MFA_ERROR'
